<script lang="js" setup>
import {defineProps} from "vue";

defineProps({
  href: {
    type: String,
    required: true,
  }
})
</script>

<template>
  <a :href="href" target="_blank">
    <div
      class="border border-white rounded-full grid place-items-center size-12 hover:bg-white group"
    >
      <div class="size-8 text-white group-hover:text-primary-dark">
        <slot />
      </div>
    </div>
  </a>
</template>

<style scoped></style>
